import Footer from './Footer'
import CourseMenu from './CourseMenu'
import CourseHeader from './CourseHeader'
import Header from './Header'
import Head from 'next/head';
import { ReactElement } from 'react';

function Layout({ children, title, description }: any) {

    return (
        <>
            <Head>
                {title && <title>{title}</title>}
                {description && <meta name="description" content={description} />}
            </Head>
            <Header />
            <CourseHeader />
            <CourseMenu />
            <div className="prose max-w-3xl mx-auto px-3 py-8">{children}</div>
            <Footer />
        </>
    )
}

export default Layout;